import { WritableSignal } from '@angular/core';
import { AbstractControl, FormGroup, ValidatorFn } from '@angular/forms';

export function checkIfPasswordsMatch(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    const formGroup = control.parent;
    if (!formGroup) return null;

    const password = formGroup.get('password')?.value;
    const confirmPassword = formGroup.get('confirmPassword')?.value;
    if (!password) return null;

    if (password !== confirmPassword) {
      return { passwordMismatch: true };
    }
    return null;
  };
}

// Validator to ensure only letters are allowed
export function notOnlyLetters(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    const value = control.value;
    const regex = /^[a-zA-Z]+$/; // Regular expression to allow only letters

    if (value && !regex.test(value)) {
      return { notOnlyLetters: true };
    }
    return null;
  };
}

export function updateErrorMessages(
  formGroup: FormGroup,
  fieldErrors: WritableSignal<{ [key: string]: string }>
): void {
  const errors: { [key: string]: string } = {}; // Reset error messages
  const controls = formGroup.controls;

  if (controls['password']?.hasError('required')) {
    errors['password'] = 'Password is required';
  } else if (controls['password']?.hasError('minlength')) {
    errors['password'] = 'Password must be at least 6 characters';
  }

  if (controls['confirmPassword']?.hasError('required')) {
    errors['confirmPassword'] = 'Field is required';
  } else if (controls['confirmPassword']?.hasError('passwordMismatch')) {
    errors['confirmPassword'] = 'Passwords do not match';
  }

  if (controls['email']?.hasError('required')) {
    errors['email'] = 'Email is required';
  } else if (controls['email']?.hasError('email')) {
    errors['email'] = 'Invalid email address';
  }

  if (controls['firstName']?.hasError('required')) {
    errors['firstName'] = 'First name is required';
  } else if (controls['firstName']?.hasError('minlength')) {
    errors['firstName'] = 'First name must be at least 2 characters';
  } else if (controls['firstName']?.hasError('notOnlyLetters')) {
    errors['firstName'] = 'First name can only contain letters';
  }

  if (controls['lastName']?.hasError('required')) {
    errors['lastName'] = 'Last name is required';
  } else if (controls['lastName']?.hasError('minlength')) {
    errors['lastName'] = 'Last name must be at least 2 characters';
  } else if (controls['lastName']?.hasError('notOnlyLetters')) {
    errors['lastName'] = 'Last name can only contain letters';
  }

  fieldErrors.set(errors); // Update the fieldErrors signal with the new errors
}
